import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { Icon } from '@nazka/nazka.mapframe.components'

import './action-btn.styl'

function ActionBtn(props) {
  const { iconProps = { icon: faPlus, size: '18px' }, onClick, iconFirst = false, children, disabled } = props

  const content = [
    <span key="icon" className="action-btn__icon">
      <Icon {...iconProps} />
    </span>,
    <span key="text" className="action-btn__text ellipsis" style={iconFirst ? { paddingLeft: '6px' } : { paddingRight: '6px' }}>
      {children}
    </span>,
  ]

  return (
    <button type="button" disabled={disabled} className={`action-btn ${disabled ? 'action-btn--disabled' : ''}`} onClick={onClick}>
      {iconFirst ? content : content.reverse()}
    </button>
  )
}

export default ActionBtn
